import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import PurchaseOrderForm from "./PurchaseOrderForm/PurchaseOrderForm";
import { assertRequiredPoHeader, emptyPoForm, PO_API, poUrlKey } from "./data";
import { selectedPurchaseOrderPath } from "components/PimDashboard/data";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import { GlobalState } from "context/GlobalContext";
import { PoPage, PoPageHeader } from "./poUi";

const CreatePurchaseOrder = () => {
	const navigate = useNavigate();
	const { snackBar, setSnackBarOpen, setSnackBar, setLoadingOpen } = GlobalState();
	const [form, setForm] = useState(emptyPoForm());
	const [saving, setSaving] = useState(false);

	const notify = (message, severity = "success") => {
		setSnackBar({ ...snackBar, message, severity, anchorOrigin: { horizontal: "center", vertical: "top" } });
		setSnackBarOpen(true);
	};

	const handleSave = async () => {
		try {
			assertRequiredPoHeader(form);
		} catch (error) {
			notify(error.message, "warning");
			return;
		}
		setSaving(true);
		setLoadingOpen(true);
		try {
			const res = await axios.post(`${PO_API}/`, form);
			notify("Purchase order draft created");
			navigate(`/${selectedPurchaseOrderPath}?${poUrlKey}=${res.data.result.id}`);
		} catch (error) {
			notify(parseErrorMessage(error), "error");
		} finally {
			setSaving(false);
			setLoadingOpen(false);
		}
	};

	return (
		<PoPage>
			{/* <PoPageHeader
				title="Create purchase order"
				subtitle="Draft a Ginesys-ready PO. Publish from the selected PO screen when ready."
			/> */}
			<PurchaseOrderForm variant="create" value={form} onChange={setForm} onSave={handleSave} saving={saving} />
		</PoPage>
	);
};

export default CreatePurchaseOrder;
